// extracted by mini-css-extract-plugin
export default {"toggle":"puckSectionField_toggle__MBG3-"};